import Image from 'next/image';
import StripeLogoType from '@/components/Stripe/LogoType';
const PaymentAssuranceDivider = () => <div className="hidden w-1 flex-none lg:block" data-sentry-component="PaymentAssuranceDivider" data-sentry-source-file="index.tsx">
    <div className="hidden h-24 w-px bg-gray-150 lg:block dark:bg-gray-800" />
  </div>;
const PaymentAssuranceSection = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => <div className="max-h-24 max-w-60" data-sentry-component="PaymentAssuranceSection" data-sentry-source-file="index.tsx">
    <div className="flex flex-col items-center gap-1 text-center text-sm">
      <span className="font-aeonik font-semibold text-gray-950 text-xl dark:text-white">
        {title}
      </span>
      {children}
    </div>
  </div>;
const PaymentAssurance = () => <div className="flex flex-col flex-wrap items-center justify-center gap-12 px-4 sm:flex-row lg:gap-8" data-sentry-component="PaymentAssurance" data-sentry-source-file="index.tsx">
    <PaymentAssuranceSection title="Payment methods" data-sentry-element="PaymentAssuranceSection" data-sentry-source-file="index.tsx">
      <div className="mt-2 flex flex-row flex-wrap gap-2 sm:mt-4">
        <Image alt="PayPal" className="rounded" height={26} sizes="48px" src="https://cdn.uppbeat.io/images/paypal.png" unoptimized width={48} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <Image alt="American Express" height={27} sizes="96px" src="https://cdn.uppbeat.io/images/amex.png" width={48} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <Image alt="Visa" height={27} sizes="96px" src="https://cdn.uppbeat.io/images/visa.png" width={48} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <Image alt="Mastercard" height={27} sizes="128px" src="https://cdn.uppbeat.io/images/mastercard.png" width={48} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>
    </PaymentAssuranceSection>
    <PaymentAssuranceDivider data-sentry-element="PaymentAssuranceDivider" data-sentry-source-file="index.tsx" />
    <PaymentAssuranceSection title="Cancel anytime" data-sentry-element="PaymentAssuranceSection" data-sentry-source-file="index.tsx">
      <p className="text-center font-sans">
        No tie-ins, just simple plans which you can cancel at any time.
      </p>
    </PaymentAssuranceSection>
    <PaymentAssuranceDivider data-sentry-element="PaymentAssuranceDivider" data-sentry-source-file="index.tsx" />
    <PaymentAssuranceSection title="Secure payment" data-sentry-element="PaymentAssuranceSection" data-sentry-source-file="index.tsx">
      <p className="font-sans">
        Transactions are encrypted and secured with{' '}
        <span className="whitespace-nowrap">
          <StripeLogoType className="ml-0.5 inline-block align-bottom" data-sentry-element="StripeLogoType" data-sentry-source-file="index.tsx" />.
        </span>
      </p>
    </PaymentAssuranceSection>
  </div>;
export default PaymentAssurance;